<template>
  <div class="select-remote-com">
    <el-select
      v-model="optionId"
      filterable
      remote
      reserve-keyword
      :placeholder="placeholder"
      :remote-method="filterList"
      :size="size"
      :clearable="clearable"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'SelectRemoteCom',
  props: {
    value: [String, Number],
    filterName: String,
    placeholder: {
      type: String,
      default: '请输入',
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'medium',
    },
    getListFunc: {
      required: true,
      type: Function,
      default() {
        return function () {
          return []
        }
      },
    },
  },
  data() {
    return {
      optionId: '',
      options: [],
    }
  },
  watch: {
    optionId(val) {
      this.$emit('input', val)
    },
  },
  created() {
    let val = ''
    this.optionId = this.value
    if (this.filterName !== '') {
      val = this.filterName
    }
    this.getList(val)
  },
  methods: {
    async getList(val) {
      const list = await this.getListFunc(val)
      this.options = list.map(item => {
        return {
          value: item.id,
          label: item.name,
        }
      })
    },
    filterList(val) {
      this.getList(val)
    },
  },
}
</script>

<style>
</style>